import LoginPage from './LoginPage';
import { useState, createContext, useContext, useCallback } from 'react';
import MainPage from './MainPage';
import { SecondaryButton } from '../components/Button';
import { useCookies } from 'react-cookie';
import API_ROOT from '../config';
const CredentialsContext = createContext(null);

export const useCredentials = () => {
    return useContext(CredentialsContext);
};

export const useFetch = () => {
    const { accessToken, refreshToken, updateAccessToken } = useCredentials();

    const refeshAccessToken = async () => {
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }
        const payload = {
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }
        const response = await fetch(`${API_ROOT}/refresh-token`, options);
        if (!response.ok) {
            throw new Error('Unable to refresh access token');
        }
        const data = await response.json();
        updateAccessToken(data);
        return data.accessToken;
    }

    const fetchWithAuth = async (url, options = { method: 'GET' }) => {
        if (!accessToken) {
            throw new Error('No access token available');
        }
        options.headers = options.headers || {};
        options.headers['Authorization'] = 'Bearer ' + accessToken;
        options.headers['Content-Type'] = 'application/json';
        const response = await fetch(url, options);
        if (response.status === 401 && refreshToken) {
            // Attempt to refresh the token
            const newToken = await refeshAccessToken();
            if (newToken) {
                options.headers['Authorization'] = 'Bearer ' + newToken;
                return fetch(url, options); // Retry the request with the new token
            }
            throw new Error('Unauthorized, and no refresh token available');
        }

        return response;
    }

    return { fetchWithAuth };
}

export default function Launchpad() {
    const [credentials, setCredentials] = useState(null);
    const [cookies, setCookie] = useCookies(['default']);
    const [tenantId, setTenantId] = useState(cookies.tenant || '?');
    const [tenantName, setTenantName] = useState('');

    const selectTenant = (tenant) => {
        setTenantId(tenant?.id);
        setTenantName(tenant?.name);
        if (tenant)
            setCookie('tenant', tenant?.id);
    }

    const updateAccessToken = useCallback((newData) => {
        setCredentials(prev => ({ ...prev, ...newData }));
    }, [setCredentials]);

    const login = async ({ accessToken, username, refreshToken }) => {
        setCredentials({ accessToken, username, refreshToken, updateAccessToken });
    };

    const logOut = () => {
        if (!credentials?.accessToken) {
            setCredentials(null);  
            return;
        }

        const url = `${API_ROOT}/logout`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ accessToken: credentials.accessToken })
        };
        fetch(url, options).then(() => {
            setCredentials(null);
        });
    
    }

    return <CredentialsContext.Provider value={credentials}>

        <header className="App-header">
            {/* <div><img src="/logo6068.png" className="App-brand-logo" alt="logo" /></div> */}
            <img src="/launchpadfromquixant.svg" className="App-logo" alt="logo" />
            <h1>Platform Licensing</h1>
            {credentials && tenantName}
            <hr />

            {credentials &&
                <div id="header-logout"><SecondaryButton onClick={logOut}>Log out</SecondaryButton> </div>
            }
        </header>
        <main className="App-main">
            {credentials ? <MainPage tenant={tenantId} selectTenant={selectTenant} /> : <LoginPage onLogin={login} />}
        </main>
        <footer className="App-footer">
            {credentials && <>
                <hr />
                <SecondaryButton onClick={logOut}>Log out</SecondaryButton>
            </>}
        </footer>
    </CredentialsContext.Provider>
};